import moment from 'moment-timezone';

export function expiringFilter(employment) {
    return (
        employment.status === 'active' &&
        employment.end_date &&
        moment.tz(employment.end_date, employment.work_timezone) <= moment.tz(employment.work_timezone).add(30, 'days')
    );
}

export function hideFilter(listName) {
    return employment => !(employment && employment.hide && employment.hide[listName]);
}

export function onboardingFilter(employment) {
    return isOnboarding(employment) || awaitingStartOrStartedRecently(employment, 3);
}

function isOnboarding(employment) {
    return ['pending', 'submitted'].includes(employment.status);
}

function awaitingStartOrStartedRecently(employment, withinDays = 0) {
    if (employment.status !== 'active') {
        return false;
    }
    const startsAt = moment.tz(employment.start_date, employment.work_timezone);
    const earliestDisplayDate = moment.tz(employment.work_timezone).add(-withinDays, 'days');
    return startsAt >= earliestDisplayDate;
}



// WEBPACK FOOTER //
// ./src/utilities/filterJobExt.jsx